import styled from "styled-components";
import {Button} from "primereact/button";

export const Botao = styled(Button)`
  
`;

export const Icone = styled.img`
  width: 30px;
`;